'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAILED = exports.SUCCEEDED = exports.REQUESTED = exports.NOT_REQUESTED = exports.States = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = require('immutable');

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var States = exports.States = (0, _keyMirror2.default)({
  NOT_REQUESTED: null,
  REQUESTED: null,
  SUCCEEDED: null,
  FAILED: null
});

// Represents the state of of API request.
// Each request can have multiple possible states, so one boolean on its own
// isn't enough to track its state. This "enum" works better.
//
// Use RequestStates.REQUESTED, RequestStates.SUCCEEDED, etc, from the exports.
// Use PropTypes.instanceOf(RequestState) to type-check within components.
// Make use of the `should*` methods when using inside of components & actions.

var RequestState = function (_Record) {
  _inherits(RequestState, _Record);

  function RequestState() {
    _classCallCheck(this, RequestState);

    return _possibleConstructorReturn(this, (RequestState.__proto__ || Object.getPrototypeOf(RequestState)).apply(this, arguments));
  }

  _createClass(RequestState, [{
    key: 'isNotRequested',
    value: function isNotRequested() {
      return this.state === States.NOT_REQUESTED;
    }
  }, {
    key: 'isPending',
    value: function isPending() {
      return this.state === States.REQUESTED;
    }
  }, {
    key: 'isSuccessful',
    value: function isSuccessful() {
      return this.state === States.SUCCEEDED;
    }
  }, {
    key: 'isFailed',
    value: function isFailed() {
      return this.state === States.FAILED;
    }
  }, {
    key: 'isDone',
    value: function isDone() {
      return this.isSuccessful() || this.isFailed();
    }
  }, {
    key: 'shouldBeRequested',
    value: function shouldBeRequested() {
      return this.isNotRequested() || this.isFailed();
    }
  }, {
    key: 'shouldShowAsLoading',
    value: function shouldShowAsLoading() {
      return this.isNotRequested() || this.isPending();
    }
  }, {
    key: 'hasStatusCode',
    value: function hasStatusCode() {
      return this.getStatusCode() !== null;
    }
  }, {
    key: 'setStatusCode',
    value: function setStatusCode(value) {
      return this.set('statusCode', value);
    }
  }, {
    key: 'getStatusCode',
    value: function getStatusCode() {
      return this.get('statusCode');
    }
  }, {
    key: 'hasStatusMessage',
    value: function hasStatusMessage() {
      return this.getMessage() !== null;
    }
  }, {
    key: 'setStatusMessage',
    value: function setStatusMessage(value) {
      return this.set('message', value);
    }
  }, {
    key: 'getStatusMessage',
    value: function getStatusMessage() {
      return this.get('message');
    }
  }]);

  return RequestState;
}((0, _immutable.Record)({
  state: States.NOT_REQUESTED,
  statusCode: null,
  message: null
}));

exports.default = RequestState;
var NOT_REQUESTED = exports.NOT_REQUESTED = new RequestState({ state: States.NOT_REQUESTED });
var REQUESTED = exports.REQUESTED = new RequestState({ state: States.REQUESTED });
var SUCCEEDED = exports.SUCCEEDED = new RequestState({ state: States.SUCCEEDED });
var FAILED = exports.FAILED = new RequestState({ state: States.FAILED });